"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileByName = exports.createPayoutFromFile = exports.checkFile = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _reduxForm = require("redux-form");

var _slice = require("../slice");

var getCurrentUserName = function getCurrentUserName(state) {
  var _state$widgetProfile, _state$widgetProfile2, _state$widgetProfile3, _state$widgetProfile4, _name$;

  var name = (_state$widgetProfile = (_state$widgetProfile2 = state['widget/profile']) === null || _state$widgetProfile2 === void 0 ? void 0 : (_state$widgetProfile3 = _state$widgetProfile2['profile']) === null || _state$widgetProfile3 === void 0 ? void 0 : (_state$widgetProfile4 = _state$widgetProfile3['user']) === null || _state$widgetProfile4 === void 0 ? void 0 : _state$widgetProfile4['name']) !== null && _state$widgetProfile !== void 0 ? _state$widgetProfile : null;
  return Array.isArray(name) ? (_name$ = name[0]) !== null && _name$ !== void 0 ? _name$ : null : name;
};

var addUserNameDetail = function addUserNameDetail(details, userName) {
  var normalizedDetails = Array.isArray(details) ? details.filter(function (detail) {
    return detail && detail['name'] !== 'userName';
  }) : [];

  if (!userName) {
    return normalizedDetails;
  }

  return [].concat((0, _toConsumableArray2["default"])(normalizedDetails), [{
    name: 'userName',
    value: userName
  }]);
};

var checkFile = function checkFile(formData) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var form, extRegexp, match, information, _extRegexp, _match;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на проверку файла создания выплаты'
              });
              dispatch((0, _slice.checkFileRequestAction)());
              form = new FormData();
              form.append('externalId', formData['externalId']);
              form.append('shopId', formData['shopId']);
              form.append('file', formData['file']);
              extRegexp = /[^\\]*\.(\w+)$/;
              match = formData['file']['name'].match(extRegexp);

              if (!(match[1].indexOf('xlsx') === -1)) {
                _context.next = 14;
                break;
              }

              dispatch((0, _reduxForm.change)('operation-payout-from-file', 'file', null));
              dispatch(notifications.push({
                title: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430",
                content: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0444\u0430\u0439\u043B\u0430",
                mode: 'danger',
                autoClose: false
              }));
              dispatch((0, _slice.checkFileRequestFailAction)());
              return _context.abrupt("return", void 0);

            case 14:
              _context.next = 16;
              return (0, _request["default"])({
                url: '/v2/payouts/' + formData['shopId'] + '/template',
                method: 'post',
                contentType: 'multipart/form-data',
                data: form
              });

            case 16:
              information = _context.sent;
              dispatch((0, _slice.checkFileRequestSuccessAction)(information));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Успешная проверка файла создания выплаты'
              });
              _context.next = 30;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 25;
                break;
              }

              return _context.abrupt("return", void 0);

            case 25:
              dispatch((0, _slice.checkFileRequestFailAction)(_context.t0['data']));
              _extRegexp = /[^\\]*\.(\w+)$/;
              _match = formData['file']['name'].match(_extRegexp);

              if (_match[1].indexOf('xlsx') !== -1) {
                dispatch((0, _reduxForm.change)('operation-payout-from-file', 'file', null));
                dispatch(notifications.push({
                  title: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430",
                  content: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u0444\u0430\u0439\u043B\u0430",
                  mode: 'danger',
                  autoClose: false
                }));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при проверке файла'
              });

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.checkFile = checkFile;

var createPayoutFromFile = function createPayoutFromFile(payoutData) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch, getState) {
      var userName, payload, result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на создание выплат из файла'
              });
              dispatch((0, _slice.createPayoutsFromFileRequestAction)());
              userName = getCurrentUserName(getState());
              payload = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payoutData), {}, {
                payouts: Array.isArray(payoutData['payouts']) ? payoutData['payouts'].map(function (payout) {
                  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payout), {}, {
                    details: addUserNameDetail(payout['details'], userName)
                  });
                }) : []
              });
              _context2.next = 7;
              return (0, _request["default"])({
                url: '/payouts/file',
                method: 'post',
                contentType: 'multipart/form-data',
                data: payload
              });

            case 7:
              result = _context2.sent;
              dispatch((0, _slice.createPayoutsFromFileRequestSuccessAction)());
              dispatch((0, _dialog.closeDialog)('create-payouts-from-file'));

              if (result['hasTwoFA']) {
                (0, _logger.push)({
                  owner: 'Navigate',
                  message: 'Необходимо ввести TwoFA для подтверждения выплат'
                });
                dispatch((0, _dialog.openDialog)('confirm-twoFA', {
                  id: result['token2FA'],
                  isFile: true
                }));
              } else {
                dispatch((0, _dialog.openDialog)('payout-from-file-success'));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Успешное создание выплат из файла'
              });
              _context2.next = 22;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 18:
              dispatch((0, _dialog.closeDialog)('create-payouts-from-file'));
              dispatch((0, _slice.createPayoutsFromFileRequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании выплат из файла'
              });

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 14]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.createPayoutFromFile = createPayoutFromFile;

var getFileByName = function getFileByName(shopId) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Скачивание файла по имени'
              });
              _context3.next = 4;
              return (0, _request["default"])({
                url: '/v2/payouts/' + shopId + '/template',
                method: 'get',
                contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                responseType: 'blob'
              });

            case 4:
              result = _context3.sent;
              (0, _utils.saveAs)(result, "payouts-template-shop-".concat(shopId, ".xlsx"));
              (0, _logger.push)({
                owner: 'Acts',
                message: 'Файл скачан успешно'
              });
              _context3.next = 15;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 13:
              dispatch(notifications.pushFail(_context3.t0['data']));
              (0, _logger.push)({
                owner: 'Acts',
                level: 'error',
                message: 'Ошибка при скачивании файла'
              });

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getFileByName = getFileByName;